import { ArrowForward, Error } from '@mui/icons-material';
import { SourcedCandidateStatus } from 'generated-graphql/types';
import { IconTooltip, PulsingDot } from 'common/ui';
import { Link } from 'react-router-dom';
import { Paths } from 'services/navigation/paths';
import { Loading } from 'common/ui/Loading';
import {
  mapSourcingStatuses,
  SOURCING_STATUS_MESSAGES,
  SOURCING_STATUS
} from 'modules/sourcing-shared/utils/mapSourcingStatuses';

const SourcingCandidateStatusIconComponent: React.FC<{
  sourcingStatus: SOURCING_STATUS;
  candidateId: string | null;
  sourcedCandidateId?: string | null;
  candidateBatchId: string;
}> = ({
  sourcingStatus,
  candidateId,
  sourcedCandidateId,
  candidateBatchId
}) => {
  // If we have a sourcedCandidateId, link to the Source_candidates tab
  if (sourcedCandidateId) {
    return (
      <Link
        to={`${Paths.ANALYSE}/${candidateBatchId}?tab=Source_candidates&sourcedCandidateId=${sourcedCandidateId}`}
      >
        <ArrowForward
          sx={{
            fontSize: '20px',
            color: (theme) => theme.palette.primary.main
          }}
        />
      </Link>
    );
  }

  // If we have a candidateId (from CV analysis), link to the Met knockout tab
  if (candidateId) {
    return (
      <Link
        to={`${Paths.ANALYSE}/${candidateBatchId}?tab=Candidates_with_minimum_requirements&candidateId=${candidateId}`}
      >
        <ArrowForward
          sx={{
            fontSize: '20px',
            color: (theme) => theme.palette.primary.main
          }}
        />
      </Link>
    );
  }

  switch (sourcingStatus) {
    case 'CHECKING_PROFILE':
      return (
        <span>
          <Loading size="14px" />
        </span>
      );
    case 'INVITE_SENT':
      return (
        <span>
          <PulsingDot size={8} />
        </span>
      );
    // NOTE: This should never show
    case 'DUPLICATE':
    case 'INVITE_FAILED':
      return (
        <span>
          <Error
            sx={{
              fontSize: '20px',
              color: 'error.main'
            }}
          />
        </span>
      );
  }
};

export const SourcingCandidateStatusIcon = (props: {
  status: SourcedCandidateStatus;
  candidateId?: string | null;
  sourcedCandidateId?: string | null;
  candidateBatchId: string;
}) => {
  const sourcingStatus = mapSourcingStatuses(props.status);
  const message = SOURCING_STATUS_MESSAGES[sourcingStatus];
  const hasLink = props.sourcedCandidateId || props.candidateId;
  return (
    <IconTooltip title={hasLink ? 'Sourced candidate' : message}>
      <span style={{ display: 'inline-flex' }}>
        <SourcingCandidateStatusIconComponent
          sourcingStatus={sourcingStatus}
          candidateId={props.candidateId ?? null}
          sourcedCandidateId={props.sourcedCandidateId}
          candidateBatchId={props.candidateBatchId}
        />
      </span>
    </IconTooltip>
  );
};
